import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, dateColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P411List({ dataTable, searchInfo, setSearchInfo, onChangeAction, submitForm }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    // const [globalFilter, setGlobalFilter] = useState(null);

    const actionTab = (data) => {
        setSearchInfo({
            ...searchInfo,
            editUserId: data ? data.userId : "",
        });

        onChangeAction(2, data ? "แก้ไข" : "บันทึก");
    };

    const headerLabel = <span className="hidden-responsive">เพิ่มรายการใหม่</span>;
    const header = (
        <div className="table-header">
            <Button className="p-button p-button-success btn-hidden-responsive" label={headerLabel} icon="pi pi-plus" onClick={() => actionTab()} autoFocus />
            {/* <span className="p-input-icon-left span-responsive" >
                <i className="pi pi-search" />
                <InputText type="search" placeholder="คำค้น" 
                className="btn-responsive"
                onInput={(e) => setGlobalFilter(e.target.value)}
                />
            </span> */}
        </div>
    );

    const allaction = (rowData) => {
        let labelEditShow = <span className="show-responsive">แก้ไขข้อมูล</span>;
        // let labelDelShow = <span className="show-responsive">ลบข้อมูล</span>;
        return (
            <>
                <React.Fragment>
                    <div style={{ textAlign: "center" }}>
                        <Button
                            icon="pi pi-pencil"
                            className="p-button p-button-success btn-label-responsive btn-md-responsive p-mr-2 p-mb-2"
                            // onClick={() => goPage(rowData)}
                            onClick={() => actionTab(rowData)}
                            tooltip="คลิกเพื่อ แก้ไขข้อมูล"
                            tooltipOptions={{ position: "top" }}
                            label={labelEditShow}
                        />

                        {/* <Button
                            icon="pi pi-trash"
                            className="p-button p-button-danger btn-label-responsive btn-md-responsive p-mr-2 p-mb-2"
                            onClick={() => submitForm(rowData)}
                            toolt
                            tooltip="คลิกเพื่อ ลบข้อมูล "
                            tooltipOptions={{ position: "top" }}
                            label={labelDelShow}
                        /> */}
                    </div>
                </React.Fragment>
            </>
        );
    };

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    header={header}
                    // globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column sortable field="userFullName" header="ชื่อ-นามสกุล" body={(e) => normalColumn(e, "userFullName", "ชื่อ-นามสกุล")} style={{ textAlign: "center", width: "13%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="userId" header="รหัสผู้ใช้" body={(e) => normalColumn(e, "userId", "รหัสผู้ใช้")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="userRole" header="ประเภทผู้ใช้งาน" body={(e) => normalColumn(e, "userRole", "ประเภทผู้ใช้งาน")} style={{ textAlign: "center", width: "12%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="userWorkunit" header="สังกัด/บริษัทคู่สัญญา" body={(e) => normalColumn(e, "userWorkunit", "สังกัด/บริษัทคู่สัญญา")} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="telephone" header="เบอร์โทรศัพท์" body={(e) => normalColumn(e, "telephone", "เบอร์โทรศัพท์")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="statusDesc" header="สถานะ" body={(e) => normalColumn(e, "statusDesc", "สถานะ")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="updateUserName" header="ผู้บันทึกแก้ไข" body={(e) => normalColumn(e, "updateUserName", "ผู้บันทึกแก้ไข")} style={{ textAlign: "center", width: "12%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="updateDt" header="วันที่-เวลาที่แก้ไข" body={(e) => dateColumn(e, true, "updateDt", "วันที่-เวลาที่แก้ไข")} style={{ textAlign: "center", width: "9%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column body={(e) => allaction(e)} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            </div>
        </div>
    );
}
